import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import NotificationPanel from '../components/NotificationPanel';
import EmployeeForm from '../components/EmployeeForm';
import { useEmployeeDetail } from '../hooks/useEmployeeDetail';

const EmployeeEdit: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { user } = useAuth();
    const { employee, loading, error } = useEmployeeDetail(id ? Number(id) : undefined);
    const [isNotifPanelOpen, setIsNotifPanelOpen] = useState(false);

    const handleSuccess = () => {
        // Rediriger vers la fiche après succès
        navigate(`/employees/${id}`);
    };

    if (!user) {
        navigate('/login', { replace: true });
        return null;
    }

    if (loading) {
        return (
            <div className={`flex h-screen bg-base-200 ${isNotifPanelOpen ? 'overflow-hidden' : ''}`}>
                <Sidebar />
                <div className="flex-1 flex flex-col p-6 overflow-auto">
                    <Navbar onOpenNotifPanel={() => setIsNotifPanelOpen(true)} />
                    <div className="flex justify-center items-center h-full">
                        <span className="loading loading-spinner loading-lg"></span>
                    </div>
                </div>
                <NotificationPanel 
                    isOpen={isNotifPanelOpen} 
                    onClose={() => setIsNotifPanelOpen(false)} 
                />
            </div>
        );
    }

    if (error || !employee) {
        return (
            <div className={`flex h-screen bg-base-200 ${isNotifPanelOpen ? 'overflow-hidden' : ''}`}>
                <Sidebar />
                <div className="flex-1 flex flex-col p-6 overflow-auto">
                    <Navbar onOpenNotifPanel={() => setIsNotifPanelOpen(true)} />
                    <div className="flex justify-center items-center h-full">
                        <div className="text-center">
                            <h2 className="text-2xl font-bold text-error">
                                {error || 'Employé non trouvé'}
                            </h2>
                            <button 
                                className="btn btn-warning mt-4"
                                onClick={() => navigate('/employees')}
                            >
                                Retour à la liste
                            </button>
                        </div>
                    </div>
                </div>
                <NotificationPanel 
                    isOpen={isNotifPanelOpen} 
                    onClose={() => setIsNotifPanelOpen(false)} 
                />
            </div>
        );
    }

    return (
        <div className={`flex min-h-screen bg-base-200 ${isNotifPanelOpen ? 'overflow-hidden' : ''}`}>
            <Sidebar />

            <main className="flex-1 p-6 overflow-y-auto">
                <Navbar onOpenNotifPanel={() => setIsNotifPanelOpen(true)} />

                <div className="py-4">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-3xl font-extrabold text-base-content">
                            Modifier - {employee.full_name}
                        </h2>
                        <button 
                            className="btn btn-warning"
                            onClick={() => navigate(`/employees/${employee.id}`)}
                        >
                            ← Retour à la fiche
                        </button>
                    </div>

                    <EmployeeForm 
                        mode="edit" 
                        employeeData={employee}
                        onSuccess={handleSuccess}
                    />
                </div>
            </main>

            <NotificationPanel 
                isOpen={isNotifPanelOpen} 
                onClose={() => setIsNotifPanelOpen(false)} 
            />
        </div>
    );
};

export default EmployeeEdit;
